// extracted by mini-css-extract-plugin
export default {"title":"rich-toast_title__ie51I"};